export default __webpack_public_path__ + "static/media/cytocaare-banner-07.d158443b.jpg";